import BaseForm from '../base';
export class MonitoringActionsPanelForm extends BaseForm {
    constructor(...args) {
        super(...args);
    }
}
export default {
    components: []
};
